import actionTypes from '../constants/action-types';

const setSiteId = (payload) => ({
  type: actionTypes.SET_SITE_ID,
  payload,
});

export default setSiteId;
